import React from 'react';
import { Button } from 'antd';

export function buildDbSchemaTab(context) {
  const { shouldShowPage, fetchDbSchema, schemaLoading, schemaError, dbSchema } = context;
  if (!shouldShowPage('数据库结构')) return null;

  return {
    key: 'db_schema',
    label: '数据库结构',
    children: (
      <div>
        <h3>数据库结构</h3>
        <div style={{ marginBottom: 16 }}>
          <Button
            type="primary"
            onClick={fetchDbSchema}
            loading={schemaLoading}
          >
            导出数据库结构
          </Button>
        </div>
        {schemaError && <div style={{ color: 'red', marginBottom: 16 }}>{schemaError}</div>}
        {dbSchema && (
          <div style={{ background: '#f5f5f5', padding: 16, borderRadius: 4, maxHeight: 400, overflow: 'auto' }}>
            <pre style={{ margin: 0, fontSize: 12 }}>{JSON.stringify(dbSchema, null, 2)}</pre>
          </div>
        )}
      </div>
    )
  };
}
